import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import React from 'react'
import { PayPalCustom } from './Components'


export const MainPaypal = () => {

    const initialOptions = {
        clientId: "AaHTTgecZtQsEvVyx9Q68mEuqLUiB_iWjar3tVbYev56YqpRzk_TL32-GpPglC1poxkULpYcJw1Zll5Q",
        currency: "MXN",
        intent: "capture",
        // dataClientToken: "ENWlUwSGDSWVzZlaYSEqEuAjvsONbErEp60OC43vrm9g_Dw_ZSyyXX42bR7bVwc8T1DUt3VJSFmwWOFW",

    }

  
    return (
        <PayPalScriptProvider options={initialOptions}>
            <PayPalCustom />
        </PayPalScriptProvider>
    )
}
